import { types } from "../types/types";

const initialState = {
    networkGasFees: [],
};

const networkGasFeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.NETWORK_GAS_FEES:
            return {
                ...state,
                networkGasFees: action.payload,
            };
        default:
            return state;
    }
};

export default networkGasFeeReducer;
